import React from "react";
import { Toaster } from "react-hot-toast"; // Ensure this is imported correctly
import Header from "./Header";
import Footer from "./Footer";
import { HelmetProvider, Helmet } from "react-helmet-async"; // Use react-helmet-async for better performance

const LayOut = ({
  children,
  title = "Akash Dubey",
  description = "Akash Dubey Portfolio",
  keywords = "Akash Dubey, Portfolio, Projects, Testimonials",
  author = "Akash Dubey",
}) => {
  return (
    <HelmetProvider>
      <div>
        <Helmet>
          <meta charSet="UTF-8" />
          <meta name="description" content={description} />
          <meta name="keywords" content={keywords} />
          <meta name="author" content={author} />
          <title>{title}</title>
        </Helmet>
        {/* Header Component */}
        <Header />
        {/* Main Content */}
        <main style={{ minHeight: "70vh" }}>
          <Toaster position="top-right" reverseOrder={false} />
          {children}
        </main>
        {/* Footer Component */}
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default LayOut;
